import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../reducers';
import { gridAdapter } from '../reducers/grid.reducer';

export const getGridState = createSelector(getDragonflySharedState, (state) => state.grid);

export const gridDataSelectors = gridAdapter.getSelectors();

export const getRenderGrid = createSelector(getGridState, ({ ids }) => (ids.length > 0 ? true : false));

export const getRenderNoGridResults = createSelector(getGridState, getRenderGrid, ({ showErrorMessage }, grid) => {
  return !grid && showErrorMessage ? true : false;
});

export const getDisplayedColumns = createSelector(getGridState, ({ displayedColumns }) => displayedColumns);

export const getDisplayedColumnKeys = createSelector(getGridState, ({ displayedColumns }) =>
  Object.keys(displayedColumns),
);

export const getSelectedId = createSelector(getGridState, ({ selectedId }) => selectedId);

export const getGridData = createSelector(getGridState, gridDataSelectors.selectAll);

export const getSelectedRow = createSelector(getGridState, ({ selectedRow }) => selectedRow);

export const getShowSpinner = createSelector(getGridState, ({ showSpinner }) => showSpinner);

export const getNewLiteralsData = createSelector(getGridState, ({ newLiteralsData }) => newLiteralsData);

export const getLiteralsData = createSelector(getGridState, ({ literalsData }) => literalsData);
